var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'v2-app-shell',
    {
      'v2-app-shell--drawer-open': _vm.drawerOpen,
    }
  ]},[(_vm.drawerOpen)?_c('div',{staticClass:"v2-app-shell__overlay",attrs:{"aria-hidden":"true"},on:{"click":_vm.closeDrawer}}):_vm._e(),_c('div',{class:[
      'v2-app-shell__sidebar',
      { 'is-open': _vm.drawerOpen }
    ]},[_c('AppSidebar',{attrs:{"mobile-open":_vm.drawerOpen,"collapsed":false},on:{"nav":_vm.closeDrawer}})],1),_c('div',{staticClass:"v2-app-shell__main"},[_c('AppTopbar',{attrs:{"title":_vm.title},on:{"toggle-sidebar":_vm.toggleDrawer}}),_c('main',{staticClass:"v2-app-shell__content"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }